"use client";

/**
 * Last-resort boundary, used only when the root layout itself throws (at
 * which point error.tsx cannot render, because it lives inside that
 * layout). It replaces <html>/<body>, so it can rely on nothing: no fonts,
 * no globals.css cascade, no header. Styles are therefore inline.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "2rem",
          backgroundColor: "#faf8f5",
          color: "#1c1b19",
          fontFamily: "Georgia, 'Times New Roman', serif",
        }}
      >
        <main style={{ maxWidth: "34rem" }}>
          <h1 style={{ fontSize: "1.75rem", fontWeight: 400, margin: 0 }}>
            Silk Clinical Aesthetics
          </h1>
          <p style={{ marginTop: "1.25rem", lineHeight: 1.6 }}>
            This page did not load properly. The fault is at our end.
            Reloading usually resolves it.
          </p>
          <p style={{ marginTop: "1.25rem" }}>
            <button
              type="button"
              onClick={reset}
              style={{
                font: "inherit",
                padding: "0.7rem 1.4rem",
                cursor: "pointer",
                color: "#1c1b19",
                backgroundColor: "transparent",
                border: "1px solid rgba(28, 27, 25, 0.35)",
                borderRadius: "999px",
              }}
            >
              Try again
            </button>
          </p>
          {error.digest ? (
            <p style={{ marginTop: "1.5rem", fontSize: "0.75rem", opacity: 0.5 }}>
              Reference {error.digest}
            </p>
          ) : null}
        </main>
      </body>
    </html>
  );
}
